import React, { useEffect, useState } from 'react'
import { axiosInstance } from '../../Helpers/axiosInstance'
import CheckItem from './CheckItem'
import CheckModal from '../../Modals/Check/CheckModal'

export default function CheckInfo({base, unit, added, baseList, changeSelectedBase,closeModal, setAdded }) {
    const [info, setInfo] = useState([])
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [idx, setIdx] = useState(null)

    const fetchData = async () => {
            try {
                if(base){
                    const response = await axiosInstance.get(`/admin/base-check/${base?._id}`)
                    if(!response.data.status) {
                        console.error("Failed to fetch firing info")
                        return
                    }
                    setInfo(response.data.data)
                }
            } catch (error) {
                console.error("Error fetching firing info:", error)
            }
        }

    useEffect(() => {
        fetchData()
    }, [base._id])

        useEffect(() => {
        if(added){
            fetchData()
        }
    }, [added])


    const deleteInfo = async(id) => {
        try{
            const response = await axiosInstance.delete(`/admin/base-check/${base._id}/${id}`)
            if(!response.data.status) {
                console.error("Failed to delete firing info")
                return
            }
            setInfo(response.data.data)
        }catch(error){
            console.log('error', error)
        }
    }

  return (
    <div className="" onClick={(e) => e.stopPropagation()}>
                { info && info.sort((a,b) => a.date > b.date ? -1 : 1).map((item, index) => {
                        return (
                            <CheckItem item={item} index={index} deleteInfo={deleteInfo} key={index} setIdx={setIdx} setIsOpenModal={setIsOpenModal} />
                        )
                })}
    
            {isOpenModal && <CheckModal baseList={baseList} fetchInfo={fetchData} item={info[idx]} base={base} currentUnit={unit} closeModal={() => {closeModal(); setIsOpenModal(false)}} setAdded={setAdded} changeSelectedBase={changeSelectedBase} />}
    </div>
  )
}